import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Headphones } from 'lucide-react';
import ContactForm from './components/ContactForm';
import SEO from '../../components/SEO';
import ContactInfo from './components/ContactInfo';

const ContactUs = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ fontFamily: "'DM Sans', sans-serif", backgroundColor: '#F8F9FC' }}>
      <SEO
        title="Contact Us — ADU Flow Support & Sales"
        description="Get in touch with the ADU Flow team. Contact us for product support, sales inquiries, or questions about our ADU construction CRM software."
        canonical="/contact-us"
        keywords="ADU Flow contact, ADU construction support, CRM software help, sales inquiries, customer support"
      />
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700;800&display=swap');`}</style>

      {/* Header */}
      <header style={{ background: '#0D2137', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-2 text-sm font-medium transition-colors hover:text-orange-400"
              style={{ color: 'rgba(255,255,255,0.65)' }}
            >
              <ArrowLeft size={16} />
              Back to Home
            </button>
            <img
              src="/assets/images/adu_flow_logo.png"
              alt="ADU Flow"
              className="h-10 w-auto object-contain cursor-pointer"
              style={{ filter: 'brightness(0) invert(1)' }}
              onClick={() => navigate('/')}
            />
          </div>
        </div>
      </header>

      {/* Hero */}
      <div style={{ background: 'linear-gradient(135deg, #0D2137 0%, #1B3A5C 100%)' }} className="py-14 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <div
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-semibold mb-5"
            style={{ background: 'rgba(232,115,42,0.15)', color: '#f08040', border: '1px solid rgba(232,115,42,0.3)' }}
          >
            <Headphones size={14} />
            We're here to help
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-3" style={{ letterSpacing: '-0.02em' }}>
            Contact Support
          </h1>
          <p className="text-sm" style={{ color: 'rgba(255,255,255,0.55)', maxWidth: '420px', margin: '0 auto', lineHeight: '1.7' }}>
            Have a question, need technical help, or want to share feedback? Our team is ready to assist.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid lg:grid-cols-5 gap-10 items-start">
          {/* Form — wider column */}
          <div className="lg:col-span-3">
            <ContactForm />
          </div>
          {/* Info — narrower column */}
          <div className="lg:col-span-2">
            <ContactInfo />
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer style={{ background: '#0D2137', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
            <p className="text-xs" style={{ color: 'rgba(255,255,255,0.3)' }}>&copy; 2026 ADU Flow. All rights reserved.</p>
            <div className="flex items-center gap-5">
              <a href="/privacy-policy" className="text-xs transition-colors hover:text-white" style={{ color: 'rgba(255,255,255,0.35)' }}>Privacy</a>
              <a href="/terms-of-use" className="text-xs transition-colors hover:text-white" style={{ color: 'rgba(255,255,255,0.35)' }}>Terms</a>
              <a href="mailto:support@aduflow.net" className="text-xs transition-colors hover:text-white" style={{ color: 'rgba(255,255,255,0.35)' }}>support@aduflow.net</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactUs;
